import React from 'react';
import { useTranslation } from 'react-i18next';
import DashboardMainTitle from '../../dashboardTitle/DashboardMainTitle';
import DashboardContent from '../../dashboardWrapper/DashboardContent';
import Wrapper from '../../dashboardWrapper/Wrapper';
import ExpoList from './ExpoList';

const DashboardExpo = () => {
  const {t} = useTranslation();

  return (
    <Wrapper>
        <DashboardContent>
            <DashboardMainTitle> {t("dashboard_nav_virtual_expo")} </DashboardMainTitle>
            <ExpoList />
        </DashboardContent>
    </Wrapper>
  )
};

export default DashboardExpo;
